import { MarkupPlugin } from '@technology/web3d-plugin-markup';
import { Web3DViewerWrapper } from '@trimble/utilities';
import { Setter } from 'solid-js';

/**
 * Removes markup refs that lived on a departing viewer from canonical items.
 * Shared by markups (viewerMarkups) and measurements (markups).
 */
export function pruneViewerMarkupRefs<
  TItem,
  TRef extends { id: string | number },
>(
  removedViewerWrapper: Web3DViewerWrapper,
  setItems: Setter<TItem[]>,
  getRefs: (item: TItem) => TRef[],
  mapItemWithRefs: (item: TItem, refs: TRef[]) => TItem
): void {
  const markupPlugin = removedViewerWrapper.viewer.plugins.get(MarkupPlugin);
  if (!markupPlugin) {
    return;
  }

  const removedIds = new Set<string | number>(
    markupPlugin.getMarkups().map((m) => m.id)
  );
  if (removedIds.size === 0) {
    return;
  }

  setItems((prev) =>
    prev.map((item) =>
      mapItemWithRefs(
        item,
        getRefs(item).filter((ref) => !removedIds.has(ref.id))
      )
    )
  );
}
